import React, { Component } from 'react';

//styles
import './App.scss';

import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import TopSection from '../TopSection/TopSection';
import SectionTwo from '../SectionTwo/SectionTwo';
import SectionThree from '../SectionThree/SectionThree';
import SectionFour from '../SectionFour/SectionFour';
import SectionFive from '../SectionFive/SectionFive';
import SectionSix from '../SectionSix/SectionSix';
import SectionSeven from '../SectionSeven/SectionSeven';
import SectionEight from '../SectionEight/SectionEight';
import SectionNine from '../SectionNine/SectionNine';
import SectionTen from '../SectionTen/SectionTen';
import Article from '../Article/Article';
import '../../static/fonts/opensanshebrew/stylesheet.css'
import { HashRouter as Router, Route } from 'react-router-dom'
import { isMobile } from '../../static/helper'
import { GA_Event, VirtualPageview, Prof, Uri } from '../Analytics/Analytics'


class App extends Component {
  adsPush() {
    var _adsManager = new window.AdsManager();
    if (isMobile()) {
      _adsManager.defineSlots([_adsManager.transitionSlot]);
    }
    if (isMobile()) {
      window.googletag.cmd.push(() => { window.googletag.display("gpt-transition"); });
    }
  }

  componentDidMount() {
    VirtualPageview(Uri + Prof, "איראן");
    this.adsPush();
    window.history.scrollRestoration = "auto";

    window.location.hash = window.decodeURIComponent(window.location.hash);
    const handleHashChange = () => {
      const hashParts = window.location.hash.split('#');
      if (hashParts.length > 2) {
        const hash = hashParts.slice(-1)[0];
        document.querySelector(`#${hash}`).scrollIntoView();
        var scrolledY = window.scrollY;

        if (scrolledY) {
          window.scroll(0, scrolledY - 100);
        }
      }
      else {
        var scrollPos = parseInt(localStorage.getItem('scrollPos'));
        if (!(window.location.hash.indexOf("article") > -1)) {
          if (scrollPos > 0) {
            window.scrollTo(0, scrollPos);
            localStorage.setItem('scrollPos', 0);
          }
        }
      }
    };
    setTimeout(() => handleHashChange(), 500);
    window.onhashchange = handleHashChange;
  }

  goToArticle(article, title, action) {
    // Put the object into storage
    let url = `#/article/${article}`;
    GA_Event(action, title)
    localStorage.setItem('scrollPos', window.scrollY);
    window.location.href = `#/article/${article}`
  }


  renderPlaybazz() {
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        d.getElementById(id).remove();
        fjs = d.getElementsByTagName(s)[0];
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://embed.playbuzz.com/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'playbuzz-sdk'))
  }

  render() {
    return (
      <div className="App" id="App">
        <Router basename="/">
          <div>
            <Route exact path="/" render={() =>
              <div>
                <Header isArticle={false} sendGA={GA_Event} />
                <TopSection />
                <SectionTwo />
                <SectionThree />
                <SectionFour goToArticle={this.goToArticle}/>
                <SectionFive goToArticle={this.goToArticle} />
                <SectionSix />
                <SectionSeven />
                <SectionEight />
                <SectionNine/>
                <SectionTen goToArticle={this.goToArticle}/>
                {/* <SectionTen goToArticle={this.goToArticle}/>
                <SectionEleven goToArticle={this.goToArticle}/> */}
                <Footer isArticle={false} />
              </div>
            } />
            <Route path="/article/:article/:comment?" component={(router) => <div><Article router={router} renderPlaybazz={this.renderPlaybazz} /><Footer isArticle={true} /></div>} />
          </div>
        </Router>
        <div id="gpt-transition"></div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.js